import { styled } from "@mui/material";

export const MySection = styled("section")({
  height: "100vh",
  position: "relative",
  display: "flex",
  overflowX: "hidden",
  justifyContent: "center",
});
